import React, { useEffect, useState } from 'react'
import { useNavigate, createSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux"
import WellnessScore from '../WellnessScore'
import AssessmentIcon from '@mui/icons-material/Assessment'
import SummarizeIcon from '@mui/icons-material/Summarize'
import EditIcon from '@mui/icons-material/Edit'
import { Button, Grid, Box, Typography, Modal, Paper, Stack, Card, CardHeader, CardContent, CardActions, Divider } from '@mui/material'
import { surveyClear } from "../../../reducers/survey"
import { stubTrue } from 'lodash'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const PreferredCardCampaign = (props) => {
    const { user: currentUser } = useSelector((state) => state.auth);
    const AssessmentObject = props.AssessmentObject
    const navigate = useNavigate('/hra')
    
    return (
        <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
            <Card p={3} sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <CardHeader
                    title={
                        <Typography variant="h5" align="center" gutterBottom>{AssessmentObject.SurveyDescription}</Typography>
                    }
                />

                <CardContent width={"100%"}>
                    <Stack direction="column" gap={1} sx={{ width: "100%", justifyContent: "center", alignItems: "center" }}>
                        <Typography variant="subtitle1" align="center" >{AssessmentObject.CampaignContentText}</Typography>

                    </Stack>
                </CardContent>
                
                <Box  pb={2} ></Box>
            </Card>


        </motion.div>
    )

}

export default PreferredCardCampaign; 